import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { styled } from '@mui/material/styles';
import AuthBackgroundDown from '../assets/images/auth-bg-down.png';
import AuthBackgroundUp from '../assets/images/auth-bg-up.png';

const RootContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
  width: '100%',
  alignContent: 'center',
  alignItems: 'center',
  backgroundImage: `url(${AuthBackgroundDown}), url(${AuthBackgroundUp})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: '600px',
  backgroundPosition: 'bottom -120px left -120px, top -120px right -120px',
}));

const InnerContainer = styled(Box)(({ theme }) => ({
  flex: '1 1 auto',
  overflow: 'auto',
  padding: '50px 0',
  minHeight: '100%',
  '& .innerContainer': {
    backgroundColor: '#fff',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
    borderRadius: '10px',
    boxShadow: '0px 0px 15px rgb(0 0 0 / 15%)',
    maxWidth: '500px',

    [theme.breakpoints.down('xs')]: {
      maxWidth: 'calc(100% - 40px)',
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      paddingRight: theme.spacing(0),
      paddingLeft: theme.spacing(0),
    },
  },
  '& .logo': {
    '& img': {
      width: '200px',
      margin: '0 auto 20px',
      display: 'block',
    },
  },
}));

function AuthLayout({ children }) {
  return (
    <RootContainer>
      <InnerContainer display="flex" flexDirection="column" justifyContent="center">
        <Container maxWidth="sm" className="innerContainer">
          {children}
        </Container>
      </InnerContainer>
    </RootContainer>
  );
}

export default AuthLayout;
